import { faCartShopping } from '@fortawesome/pro-solid-svg-icons';
import type { PropsWithChildren } from 'react';
import styled from 'styled-components';

import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { IconButton } from '@sorare/core/src/atoms/buttons/IconButton';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Badge } from '@sorare/core/src/atoms/ui/Badge';
import { NotIOsAppFeature } from '@sorare/core/src/components/BuyableFeature';
import { DialogKey } from '@sorare/core/src/components/navigation/WithDialogs';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useGenerateDialogPath } from '@sorare/core/src/hooks/navigation/useGenerateDialogPath';

import { PromoChip } from 'atoms/PromoChip';
import { useCart } from 'hooks/useCart';

const Relative = styled(Vertical)`
  position: relative;
`;

const BottomCenter = styled(Vertical)`
  position: absolute;
  bottom: calc(-1 * var(--half-unit));
  right: 50%;
  transform: translateX(50%);
`;

export const NavigationCart = ({ children }: PropsWithChildren) => {
  const { cartCount, hasLivePromos } = useCart();
  const { sport } = useSportContext();
  const generateDialogPath = useGenerateDialogPath();
  const dialogRoute = generateDialogPath(DialogKey.checkout, sport);

  return (
    <NotIOsAppFeature exceptMarketAuthorizedIosApp>
      <ButtonBase to={dialogRoute} aria-label="Cart">
        <Horizontal>
          <Relative>
            <Badge badgeContent={cartCount} overlap="circular" color="grey">
              <IconButton
                size="medium"
                icon={faCartShopping}
                color="transparent"
                asSpan
              />
            </Badge>
            {!!hasLivePromos && (
              <BottomCenter>
                <PromoChip />
              </BottomCenter>
            )}
          </Relative>
          {children}
        </Horizontal>
      </ButtonBase>
    </NotIOsAppFeature>
  );
};
